const filesByLocalId = new Map<string, File>();

export function registerChatOutboxFile(localId: string, file: File): void {
    filesByLocalId.set(localId, file);
}

export function getChatOutboxFile(localId: string): File | undefined {
    return filesByLocalId.get(localId);
}

export function discardChatOutboxFiles(localIds: readonly string[]): void {
    for (const localId of localIds) {
        filesByLocalId.delete(localId);
    }
}
